// extracted by mini-css-extract-plugin
export default {"title":"GetPromotion_title__aTuqq","boxForm":"GetPromotion_boxForm__EjG2-","form":"GetPromotion_form__9sT+L"};